// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)
